import { useState} from 'react';
import { Form, Card, Row, Col, Button, Image } from 'react-bootstrap';
import icJobs from './assets/img/ic-job-search.svg';

const CompanyAddJobNumbers = ({ formData = {}, handleChange, handleJobNumbersSubmit, isEditPage }) => { // ✅ Ensure formData has a default value

    const [isEditing, setIsEditing] = useState(!isEditPage); // ✅ If adding, fields are enabled
    const [tempFormData, setTempFormData] = useState({ ...formData }); // ✅ Store initial values 

    const calculateOpenJobsTotal = () => {
        const total =
            (parseInt(formData.openJobsStudent) || 0) +
            (parseInt(formData.openJobsIntern) || 0) +
            (parseInt(formData.openJobsStarting) || 0) +
            (parseInt(formData.openJobs13) || 0) +
            (parseInt(formData.openJobs3) || 0);
        return total;
    };

    // ✅ Enable editing mode
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // ✅ Store previous values
    };

    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleJobNumbersSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleJobNumbersSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleJobNumbersSubmit is not a function.');
        }
    };

    // ✅ Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false);
        Object.keys(tempFormData).forEach((key) => {
            handleChange({ target: { name: key, value: tempFormData[key] } });
        });
    };

    return (
        <> 
            <Card className="mb-4">
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            {isEditPage && (
                                <div className="float-end">
                                    {!isEditing ? (
                                        <Button variant="outline-secondary" className="btn-sm" onClick={handleEditClick}>Edit</Button>
                                    ) : (
                                        <>
                                            <Button variant="outline-secondary" className="btn-sm me-2" onClick={handleCancelClick}>Cancel</Button>
                                            <Button variant="primary" className="btn-sm" onClick={handleSaveClick}>Save</Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3><span className="item-number">3.</span> Number of jobs</h3>
                            <hr />
                        </Col>
                    </Row>
                    <Row>
                        <>
                            {isEditing ? (
                                <>
                                    <Col md={2}>
                                        {/* Student Jobs */}
                                        <Form.Group controlId="openJobsStudent">
                                            <Form.Label>Student Jobs</Form.Label>
                                            <div className="has-after">
                                                <Form.Control
                                                    type="number"
                                                    name="openJobsStudent"
                                                    value={formData.openJobsStudent}
                                                    onChange={handleChange}
                                                    disabled={!isEditing} // ✅ Disable when not editing
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        {/* Intern jobs */}
                                        <Form.Group controlId="openJobsIntern">
                                            <Form.Label>Intern jobs</Form.Label>
                                            <div className="has-after">
                                                <Form.Control
                                                    type="number"
                                                    name="openJobsIntern"
                                                    value={formData.openJobsIntern}
                                                    onChange={handleChange}
                                                    disabled={!isEditing} // ✅ Disable when not editing
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        {/* Starting jobs */}
                                        <Form.Group controlId="openJobsStarting">
                                            <Form.Label>Starting jobs</Form.Label>
                                            <div className="has-after">
                                                <Form.Control
                                                    type="number"
                                                    name="openJobsStarting"
                                                    value={formData.openJobsStarting || ''} // ✅ Ensure fallback value}
                                                    onChange={handleChange}
                                                    disabled={!isEditing} // ✅ Disable when not editing
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        {/* Jobs 1-3 years */}
                                        <Form.Group controlId="openJobs13">
                                            <Form.Label>Jobs 1-3 years</Form.Label>
                                            <div className="has-after">
                                                <Form.Control
                                                    type="number"
                                                    name="openJobs13"
                                                    value={formData.openJobs13 || ''} // ✅ Ensure fallback value}
                                                    onChange={handleChange}
                                                    disabled={!isEditing} // ✅ Disable when not editing
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        {/* Jobs 3+ years */}
                                        <Form.Group controlId="openJobs3">
                                            <Form.Label>Jobs 3+ years</Form.Label>
                                            <div className="has-after equal-to">
                                                <Form.Control
                                                    type="number"
                                                    name="openJobs3"
                                                    value={formData.openJobs3 || ''} // ✅ Ensure fallback value}
                                                    onChange={handleChange}
                                                    disabled={!isEditing} // ✅ Disable when not editing
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        {/* Open jobs (calculated) */}
                                        <Form.Group controlId="openJobsTotal">
                                            <Form.Label>Open jobs</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="openJobsTotal"
                                                value={calculateOpenJobsTotal()}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                </>
                            ) : (
                                // Not editing
                                <>
                                    <Col md={2}>
                                        {/* Student Jobs */}
                                        <div className="icon-text has-after">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icJobs} alt="Student Jobs" />
                                            </span>
                                            <span className="text">
                                                Student jobs
                                                <br />
                                                <strong>
                                                    {formData.openJobsStudent ? (
                                                        formData.openJobsStudent
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        {/* Intern jobs */}
                                        <div className="icon-text has-after">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icJobs} alt="Intern jobs" />
                                            </span>
                                            <span className="text">
                                                Intern jobs
                                                <br />
                                                <strong>
                                                    {formData.openJobsIntern ? (
                                                        formData.openJobsIntern
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        {/* Starting jobs */}
                                        <div className="icon-text has-after">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icJobs} alt="Starting jobs" />
                                            </span>
                                            <span className="text">
                                                Starting jobs
                                                <br />
                                                <strong>
                                                    {formData.openJobsStarting ? (
                                                        formData.openJobsStarting
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        {/* Jobs 1-3 years */}
                                        <div className="icon-text has-after">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icJobs} alt="Jobs 1-3 years" />
                                            </span>
                                            <span className="text">
                                                Jobs 1-3 years
                                                <br />
                                                <strong>
                                                    {formData.openJobs13 ? (
                                                        formData.openJobs13
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        {/* Jobs 3+ years */}
                                        <div className="icon-text has-after equal-to">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icJobs} alt="Jobs 3+ years" />
                                            </span>
                                            <span className="text">
                                                Jobs 3+ years
                                                <br />
                                                <strong>
                                                    {formData.openJobs3 ? (
                                                        formData.openJobs3
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        {/* Open jobs */}
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icJobs} alt="Open jobs" />
                                            </span>
                                            <span className="text">
                                                Open jobs
                                                <br />
                                                <strong>
                                                    {calculateOpenJobsTotal() ? (
                                                        calculateOpenJobsTotal()
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                </>
                            )}
                        </>
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};

export default CompanyAddJobNumbers;
